import React from "react";
import {Spin} from "antd";
import "./Spinner.scss";
import {SpinSize} from "antd/lib/spin";
import {
    getTranslate,
    TranslateFunction,
} from "react-localize-redux";
import {connect} from "react-redux";
import StoreState from "../../../interfaces/store/storeState";

interface OwnProps {
    // eslint-disable-next-line react/require-default-props
    delay?: number
    // eslint-disable-next-line react/require-default-props
    size?: SpinSize
}

interface StateProps {
    translate: TranslateFunction
}

type Props = StateProps & OwnProps;

const Spinner: React.FC<Props> = (props: Props): React.ReactElement => (
    <Spin
        wrapperClassName="df-spin-wrapper"
        size={props.size}
        spinning
        delay={props.delay || 300}
        tip={props.translate("components.common.Spinner.loading.text") as string}
    >
        <div/>
    </Spin>
);

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(Spinner);
